function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 8.27339,
  cy: 8.06453,
  r: 7.3072
});

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  cx: 5.8375,
  cy: 8.06455,
  r: 1.21787,
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("circle", {
  cx: 10.7091,
  cy: 8.06455,
  r: 1.21787,
  fill: "white"
});

var _ref5 = /*#__PURE__*/React.createElement("circle", {
  cx: 14.2104,
  cy: 14.9151,
  r: 5.9371,
  fill: "#F1F2F5"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M12.4755 16.8916V16.0391L14.1138 14.3192C14.3214 14.0919 14.4696 13.8942 14.5586 13.7261C14.6525 13.5532 14.6994 13.3802 14.6994 13.2072C14.6994 12.7624 14.4251 12.54 13.8766 12.54C13.6641 12.54 13.4515 12.582 13.239 12.666C13.0265 12.7451 12.8189 12.8687 12.6163 13.0367L12.2456 12.1916C12.4631 12.0038 12.73 11.8555 13.0463 11.7468C13.3675 11.6381 13.6962 11.5837 14.0322 11.5837C14.6154 11.5837 15.0602 11.7147 15.3666 11.9766C15.678 12.2336 15.8337 12.6018 15.8337 13.0812C15.8337 13.3975 15.7595 13.7014 15.6113 13.993C15.4679 14.2797 15.2307 14.591 14.8996 14.9271L13.8914 15.9501H16.0264V16.8916H12.4755Z",
  fill: "#23244D",
  fillOpacity: 0.5
});

var SvgCompetitors2Icon = function SvgCompetitors2Icon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCompetitors2Icon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/competitors-2-icon.573ef914.svg";
export { ForwardRef as ReactComponent };